import Cookies from "js-cookie";
import {
  ADMIN_CREATE_OVERALL_MATERIAL_URL,
  ADMIN_UPDATE_OVERALL_MATERIAL_URL,
  ADMIN_DELETE_OVERALL_MATERIAL_URL,
  ADMIN_GET_OVERALL_MATERIALS_URL,
  ADMIN_GET_OVERALL_MATERIAL_URL,
  CREATE_OVERALL_MATERIAL_URL,
  UPDATE_OVERALL_MATERIAL_URL,
  DELETE_OVERALL_MATERIAL_URL,
  GET_OVERALL_MATERIALS_URL,
  GET_OVERALL_MATERIAL_URL,
  GET_OVERALL_MATERIALS_URL_TEACHER,
  CREATE_OVERALL_MATERIAL_URL_TEACHER,
  UPDATE_OVERALL_MATERIAL_URL_TEACHER,
  DELETE_OVERALL_MATERIAL_URL_TEACHER,
  GET_OVERALL_MATERIAL_URL_TEACHER,
} from "../apiurls/apiurls";

const isAdmin = () => Cookies.get("role") === "admin";
const isTeacher = () => Cookies.get("role") === "teacher";
const getAuthToken = () =>
  isAdmin() ? Cookies.get("admin_token") : Cookies.get("institution_token");

const getHeaders = () => {
  const headers = { "Content-Type": "application/json" };
  const token = getAuthToken();
  if (token) {
    headers["Authorization"] = ` ${token}`;
  }
  return headers;
};

export const getOverallMaterials = async (courseKey) => {
  try {
    const baseGetUrl = isAdmin()
      ? ADMIN_GET_OVERALL_MATERIALS_URL
      : isTeacher()
        ? GET_OVERALL_MATERIALS_URL_TEACHER
        : GET_OVERALL_MATERIALS_URL;
    let url = baseGetUrl;

    if (typeof courseKey === "string" && courseKey.trim()) {
      const params = new URLSearchParams({ course_key: courseKey.trim() });
      url = `${baseGetUrl}?${params.toString()}`;
    }

    const response = await fetch(url, {
      method: "GET",
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return Array.isArray(data?.data)
      ? data.data
      : Array.isArray(data)
        ? data
        : [];
  } catch (error) {
    console.error("Error fetching overall materials:", error);
    throw error;
  }
};

export const getOverallMaterial = async (id) => {
  if (!id) throw new Error("Overall material id is required to fetch");

  try {
    const baseGetSingleUrl = isAdmin()
      ? ADMIN_GET_OVERALL_MATERIAL_URL
      : isTeacher
        ? GET_OVERALL_MATERIAL_URL_TEACHER
        : GET_OVERALL_MATERIAL_URL;
    const url = `${baseGetSingleUrl}?id=${encodeURIComponent(id)}`;
    const response = await fetch(url, {
      method: "GET",
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || data;
  } catch (error) {
    console.error("Error fetching overall material:", error);
    throw error;
  }
};

export const createOverallMaterial = async (payload, courseKey, file) => {
  try {
    const baseCreateUrl = isAdmin()
      ? ADMIN_CREATE_OVERALL_MATERIAL_URL
      : isTeacher()
        ? CREATE_OVERALL_MATERIAL_URL_TEACHER
        : CREATE_OVERALL_MATERIAL_URL;
    let url = baseCreateUrl;

    if (typeof courseKey === "string" && courseKey.trim()) {
      const params = new URLSearchParams({ course_key: courseKey.trim() });
      url = `${baseCreateUrl}?${params.toString()}`;
    }

    let options;

    if (file) {
      const formData = new FormData();
      Object.keys(payload || {}).forEach((key) => {
        if (key === "content") return;
        if (payload[key] !== undefined && payload[key] !== null) {
          formData.append(key, payload[key]);
        }
      });
      formData.append("file", file);

      options = {
        method: "POST",
        headers: getHeadersWithoutContentType(),
        body: formData,
      };
    } else {
      options = {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify(payload),
      };
    }

    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error creating overall material:", error);
    throw error;
  }
};

export const updateOverallMaterial = async (id, payload, file) => {
  if (!id) throw new Error("Overall material id is required to update");

  try {
    const baseUpdateUrl = isAdmin()
      ? ADMIN_UPDATE_OVERALL_MATERIAL_URL
      : isTeacher
        ? UPDATE_OVERALL_MATERIAL_URL_TEACHER
        : UPDATE_OVERALL_MATERIAL_URL;
    const url = `${baseUpdateUrl}?id=${encodeURIComponent(id)}`;

    let options;

    if (file) {
      const formData = new FormData();
      Object.keys(payload || {}).forEach((key) => {
        if (key === "content") return;
        if (payload[key] !== undefined && payload[key] !== null) {
          formData.append(key, payload[key]);
        }
      });
      formData.append("file", file);

      options = {
        method: "PUT",
        headers: getHeadersWithoutContentType(),
        body: formData,
      };
    } else {
      options = {
        method: "PUT",
        headers: getHeaders(),
        body: JSON.stringify(payload),
      };
    }

    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error updating overall material:", error);
    throw error;
  }
};

export const deleteOverallMaterial = async (id) => {
  if (!id) throw new Error("Overall material id is required to delete");

  try {
    const baseDeleteUrl = isAdmin()
      ? ADMIN_DELETE_OVERALL_MATERIAL_URL
      : isTeacher
        ? DELETE_OVERALL_MATERIAL_URL_TEACHER
        : DELETE_OVERALL_MATERIAL_URL;
    const url = `${baseDeleteUrl}?id=${encodeURIComponent(id)}`;
    const response = await fetch(url, {
      method: "DELETE",
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error deleting overall material:", error);
    throw error;
  }
};

const getHeadersWithoutContentType = () => {
  const token = getAuthToken();
  if (token) {
    return { Authorization: ` ${token}` };
  }
  return {};
};
